// @ts-nocheck
export const CLI_OPTION_VIRTUAL = "virtual";
export const CLI_OPTION_ACTUAL = "actual";

export function getAgentCliOption(_userData) {
  // const raw =
  //   userData?.agentData?.cli_option ||
  //   userData?.agent_details?.cli_option ||
  //   "actual";
  // return String(raw).trim().toLowerCase() === CLI_OPTION_VIRTUAL
  //   ? CLI_OPTION_VIRTUAL
  //   : CLI_OPTION_ACTUAL;
  return CLI_OPTION_ACTUAL;
}

export function resolveCliNumber(_cliOption, { customerNumber, didNumber } = {}) {
  const customer = customerNumber || null;
  const did = didNumber || null;
  // return String(cliOption || CLI_OPTION_ACTUAL).trim().toLowerCase() === CLI_OPTION_VIRTUAL
  //   ? did || customer
  //   : customer || did;
  return customer || did;
}

// Agent-level "mask customer number" toggle (separate from cli_option).
export function getAgentMasking(userData) {
  return Boolean(
    userData?.agentData?.is_masking_enabled ??
      userData?.agent_details?.is_masking_enabled ??
      false,
  );
}

// Mask a number for display: keep the first 4 characters visible, replace every
// remaining digit with "X" (e.g. "9876543210" -> "9876XXXXXX"). Non-digits after
// the first 4 are left as-is. Idempotent (masking a masked value is a no-op).
export function maskNumber(value) {
  if (value === null || value === undefined) return value;
  const str = String(value);
  if (str.length <= 4) return str;
  return str.slice(0, 4) + str.slice(4).replace(/\d/g, "X");
}

/** Hangup cause for channel / licence shortage (hangup_cause_codes id 57: code 803, legacy 411). */
export const CHANNEL_LICENCE_SHORTAGE_HANGUP_CODE = "803";
export const CHANNEL_LICENCE_SHORTAGE_HANGUP_CODES = new Set(["803", "411"]);

export function isChannelLicenceShortageHangup(hangupCause) {
  if (hangupCause === null || hangupCause === undefined || hangupCause === "") {
    return false;
  }
  const raw = String(hangupCause).trim();
  if (CHANNEL_LICENCE_SHORTAGE_HANGUP_CODES.has(raw)) return true;
  const upper = raw.toUpperCase();
  return (
    upper === "CHANNEL_NOT_AVAILABLE" ||
    upper.includes("LICENSE CHANNEL NOT AVAILABLE") ||
    upper.includes("LICENCE CHANNEL NOT AVAILABLE")
  );
}

/** Fully hide every digit (used for the channel-shortage hangup cause). */
export function fullyMaskNumber(value) {
  if (value === null || value === undefined) return value;
  const str = String(value);
  if (!str) return str;
  return str.replace(/\d/g, "X");
}

/** Mask phone fields on a report row on channel-shortage hangup (or force). Rows stay visible. */
export function maskReportRowNumbers(row, { force = false } = {}) {
  if (!row || typeof row !== "object") return row;
  if (!force && !isChannelLicenceShortageHangup(row.hangup_cause)) return row;
  return {
    ...row,
    caller_number: fullyMaskNumber(row.caller_number),
    callee_number: fullyMaskNumber(row.callee_number),
    agent_number: fullyMaskNumber(row.agent_number),
  };
}

/**
 * Prefer full mask for the channel-shortage hangup, else optional agent partial mask.
 */
export function maskNumberForHangup(value, hangupCause, agentMaskingEnabled = false) {
  if (isChannelLicenceShortageHangup(hangupCause)) {
    return fullyMaskNumber(value);
  }
  return agentMaskingEnabled ? maskNumber(value) : value;
}

// Convenience: mask only when enabled, else return value unchanged.
export function maskIfEnabled(enabled, value) {
  return enabled ? maskNumber(value) : value;
}
